const API_URL = process.env.REACT_APP_API_URL;

let apiUrls =  {
    elements: `${API_URL}/corner-staple-machines`,
    saveSpeedTable: `${API_URL}/corner-staple-machine/save-speed-table`
};

export default apiUrls;
